<script>
import Overview from './list/overview.vue'
import Table from './list/table.vue'

export default {
  components: { Overview, Table },
  page: {
    title: 'Member List Agent Admin',
    meta: [
      { name: 'description', content: 'The Member List Agent Admin page.' },
    ],
  },
  data() {
    return {
      searchGender: null,
      searchStatus: null,
      searchAge: null,
    }
  },
  created() {
    const user = this.$store.getters['auth/getCurrentUser']
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          agent_code: user?.agent?.agent_code,
        },
      })
      // eslint-disable-next-line handle-callback-err
      .catch((error) => {})
  },
  methods: {
    handleSearchGender(v) {
      this.searchGender = v
    },
    handleSearchStatus(v) {
      this.searchStatus = { member_status: v }
    },
    handleSearchAge(v) {
      this.searchAge = { age_ratio: v }
    },
  },
}
</script>

<template>
  <div>
    <Overview
      @search-gender="handleSearchGender"
      @search-status="handleSearchStatus"
      @search-age="handleSearchAge"
    />
    <Table
      :search-gender="searchGender"
      :search-status="searchStatus"
      :search-age="searchAge"
    />
  </div>
</template>
